export default "__VITE_ASSET__CUqDY0ZL__"